import { action, IObservableValue, observable } from 'mobx';

export class ActivePageStore {
    searchInMap: string;
    mapObjectCardPage: string;
    complaintByErrorPage: string;
    @observable activePage: IObservableValue<string | null>;

    constructor() {
        this.searchInMap = 'searchInMap';
        this.mapObjectCardPage = 'mapObjectCardPage';
        this.complaintByErrorPage = 'complaintByErrorPage';
        this.activePage = observable.box<string | null>(null);
    }

    /**
     * Получить название активной страницы на левой панели
     */
    @action('get active page')
    getActivePage = (): string | null => {
        return this.activePage.get();
    };

    /**
     * Обновить название активной страницы на левой панели
     */
    @action('set active page')
    setActivePage = (activePage: string | null): void => {
        this.activePage.set(activePage);
    };
}

const activePageStore = new ActivePageStore();

export default activePageStore;
